import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import { ConfirmModalComponent } from '@ispm/layout/components/modals/confirm-modal/confirm-modal.component';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { TherapyMatchService } from "@ispm/migration/services/therapy-match.service";
import { TestService } from '@ispm/dashboard/test/services/test.service';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'gen-therapy-match',
    templateUrl: './therapy-match.component.html',
    styleUrls: ['./therapy-match.component.scss'],
})

export class TherapyMatchComponent implements OnInit {

    public therapies: any;
    public noTherapiesMessage: any;
    public provider: any;
    public filteredFdaApproved = [];
    public filteredFdaApprovedOutside = [];
    public filteredFdaNotApproved = [];

    constructor(
        private _therapyMatchService: TherapyMatchService,
        private testService: TestService,
        private activatedRoute: ActivatedRoute,
        private coreActionCreator: CoreActionCreatorService,
        protected modalLoader: DynamicModalLoaderService,
        private cdr: ChangeDetectorRef
    ){
    }

    ngOnInit(): void {
        this.coreActionCreator.setLoader(true);
        const currentRevisionId = this.activatedRoute.parent.snapshot.params.revisionId;
        this._therapyMatchService.getAll(currentRevisionId).subscribe((res) => {
            this.therapies = res.body;
            this.cdr.markForCheck();
            if (res.body.length === 0) {
              this.noTherapiesMessage = this.testService.testConfiguration.therapyMatchEmptyMessage;
              this.provider = null;
            } else {
              this.provider = 'Powered by N-of-One®';

              this.noTherapiesMessage = null;
              this.therapies
                .forEach(therapy =>
                  therapy.drugs.forEach(drug => {
                      if (drug.therapeuticLevelOfEvidence === undefined || drug.therapeuticLevelOfEvidence === null ||
                        this.testService.getHiddenLevelsOfEvidence().includes(drug.therapeuticLevelOfEvidence)) {
                        drug.displayName = drug.name;
                      }
                      else {
                        drug.displayName = drug.name + ' (" + drug.therapeuticLevelOfEvidence + ")';
                      }
                    }
                  )
                );
            }
            this.coreActionCreator.setLoader(false);
        });
    }

    openGeneRole(gene: any) {
        const geneRole = gene.role ? gene.role : gene.roleInCancer;
        this.modalLoader.popupModal(ConfirmModalComponent,
            {
              title: 'Gene Role',
              content: geneRole,
            }, ModalTypes.NONE).subscribe(() => {
          });
    }

    openAberrationEffect(therapyEffect: any) {
        this.modalLoader.popupModal(ConfirmModalComponent,
            {
              title: 'Aberration effect',
              content: therapyEffect,
            }, ModalTypes.NONE).subscribe(() => {
        });
    }

    fda_approved(drugs: any) {
        this.filteredFdaApproved = drugs.filter(drug => {
            return drug.fdaApprovedForIndication;
        });
        return this.filteredFdaApproved;
    }

    fda_approved_outside(drugs: any) {
        this.filteredFdaApprovedOutside = drugs.filter(drug => {
            return drug.fdaApprovedOutsideIndication && !drug.fdaApprovedForIndication;
        });
        return this.filteredFdaApprovedOutside;
    }

    showDrugIndication(drug: any) {
        const title = 'Indication: ';
        return title + drug.diseaseInOtherIndications.join();
    }

    showStatusIndication(drug: any) {
        const title = 'Status: ';
        return title + drug.fdaStatusWithinIndication;
    }

    fda_not_approved(drugs: any) {
        this.filteredFdaNotApproved = drugs.filter(drug => {
            return drug.investigationalForIndication && !drug.fdaApprovedForIndication;
        });
        return this.filteredFdaNotApproved;
    }

    openTherapeuticRelevance(therapy: any) {
        this.modalLoader.popupModal(ConfirmModalComponent,
            {
              title: 'Detailed therapeutic relevance',
              content: therapy.theraputicRelevanceDetails,
            }, ModalTypes.NONE).subscribe(() => {
        });
    }

}
